const toggles = [...document.querySelectorAll('.js-dropdown-toggle')];


toggles.forEach((toggle) => {
    const menu = toggle.parentNode.querySelector('.js-dropdown-menu');

    toggle.addEventListener('click', () => {
        toggle.classList.toggle('is-active');
        menu.classList.toggle('is-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/navbarDropdowns.js